import styled from 'styled-components';

export const FooterArea = styled.div`
    height:100px;
    display:flex;
    justify-content:center;
    align-items:center;
    text-align:center;
    color:#999;
    font-size:14px;
    border-top:1px solid #CCC;
    margin-top:20px;
`;